<template>
	<dms-wrapper ref="wrapper" :label="labelText" v-bind="{span, wrapp, showLabel}" :disabled="isDisabled">
		<el-upload ref="upload" v-bind="{drag, ...$attrs}" :disabled="isDisabled" :file-list="fileList" class="frm-group" :data-cy="labelKey">
			<slot>
				<template v-if="drag">
					<i class="el-icon-upload" />
					<div class="el-upload__text">
						{{ placeholderText }}
					</div>
				</template>
			</slot>
		</el-upload>
		<div v-if="hasUploadListener" :style="{textAlign: 'center'}">
			<dms-button v-if="hasUploadListener" :disabled="isUploadDisabled" :text="uploadText" type="info" @click="$emit('upload')" />
		</div>
	</dms-wrapper>
</template>

<script>
import { BaseInput } from '#components/dms/common/baseInput';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default BaseInput.extend({
	name: 'DmsInputUpload',
	components: { DmsWrapper },
	inheritAttrs: false,
	props: {
		placeholderKey: { type: String, default: 'DRAG_UPLOAD' },
		drag: { type: Boolean, default: true },
		uploadBtnKey: { type: String, default: 'UPLOAD' },
		uploadBtn: String,
		fileList: { type: Array, default: () => [] },
	},
	computed: {
		uploadBtnText() {
			return this.getText(this.uploadBtn, this.uploadBtnKey, undefined);
		},
		uploadText() {
			return this.LocalizePopisostatni('Upload');
		},
		isUploadDisabled() {
			return !this.fileList.length;
		},
		hasUploadListener() {
			return this.$listeners && this.$listeners.upload;
		},
	},
});
</script>
